import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const orderId = searchParams.get("orderId");
  const [status, setStatus] = useState("CHECKING");

  useEffect(() => {
    if (!orderId) {
      setStatus("FAILED");
      return;
    }

    let attempts = 0;

    const checkOrder = async () => {
      try {
        const res = await fetch(
          `https://api.freshcart4u.com/api/orders/${orderId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        const data = await res.json();

        console.log("🧪 ORDER:", data);

        const isPaid =
          data?.isPaid ||
          data?.order?.isPaid ||
          data?.data?.isPaid;

        if (isPaid) {
          setStatus("SUCCESS");

          setTimeout(() => {
            navigate(`/order-confirmation/${orderId}`);
          }, 2000);
        } else {
          attempts++;

          if (attempts > 10) {
            setStatus("FAILED");
          } else {
            setTimeout(checkOrder, 2000);
          }
        }
      } catch (err) {
        console.log(err);
        setStatus("FAILED");
      }
    };

    checkOrder();
  }, [orderId, navigate]);

  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      {status === "CHECKING" && <h2>Processing Payment...</h2>}
      {status === "SUCCESS" && <h2>✅ Payment Success</h2>}
      {status === "FAILED" && (
        <>
          <h2>❌ Payment Issue</h2>
          <button onClick={() => navigate("/orders")}>
            Go to Orders
          </button>
        </>
      )}
    </div>
  );
};

export default PaymentSuccess;